module.exports = __webpack_public_path__ + "static/media/members-main.fb5696ea.svg";